import { render } from "./RouteNotFoundError.vue?vue&type=template&id=34159a26&scoped=true"
import script from "./RouteNotFoundError.vue?vue&type=script&lang=js"
export * from "./RouteNotFoundError.vue?vue&type=script&lang=js"

import "./RouteNotFoundError.vue?vue&type=style&index=0&id=34159a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34159a26"]])

export default __exports__